<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title">Select Payment Gateway</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
    </div>

    <div class="modal-body">
        <div class="payment-container">
            <ng-container *ngIf="gateways?.length > 0; else noGateways">
                <ng-container *ngFor="let gateway of gateways; trackBy: trackByGateway">
                    <div class="payment-gateway-option">
                        <input type="radio" name="paymentMethod" [id]="'gateway-' + gateway.id" [value]="gateway.id"
                            [(ngModel)]="paymentFormObject.selectedGatewayId"
                            (ngModelChange)="onPaymentMethodChange(gateway)" class="visually-hidden">

                        <label [for]="'gateway-' + gateway.id" class="gateway-card"
                            [class.selected]="paymentFormObject.selectedGatewayId === gateway.id">

                            <div class="gateway-content">
                                <div class="gateway-info">
                                    <h3 class="gateway-name">{{ gateway.gatewayName }}</h3>
                                </div>

                                <div class="gateway-logo">
                                    <img [src]="getGatewayImage(gateway.gatewayName)" [alt]="gateway.gatewayName + ' logo'"
                                        class="gateway-logo-img">
                                </div>
                            </div>
                        </label>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noGateways>
                <div class="no-gateways-message">
                    No payment options available at this time.
                </div>
            </ng-template>

            <div class="notice-section">
                <div class="notice-card">
                    <div class="notice-header">
                        <span class="notice-badge">Important Notice</span>
                        <h4 class="notice-title">Non-Refundable Payment</h4>
                    </div>
                    <div class="notice-body">
                        <p>
                            E-visa application fees are charged for processing and assessment services. Once payment has been made, it cannot be refunded, regardless of the outcome of the application. 
                        </p>
                        <p class="policy-note">
                            Please review the full policy before proceeding:
                        </p>
                        <p class="policy-link-container">
                            <a [href]="refundPolicyUrl" target="_blank" class="policy-link">Nigeria Immigration Refund Policy</a>
                        </p>
                    </div>
                </div>

                <div class="terms-acceptance">
                    <span class="acknowledgement-title">Acknowledgement:</span>
                    <label class="checkbox-wrapper">
                        <input type="checkbox" [(ngModel)]="termsAccepted" class="custom-checkbox">
                        <span class="checkbox-label">
                            By proceeding, I confirm that I have read and understood the refund policy, and I agree that this payment is final and non-refundable.
                        </span>
                    </label>
                </div>
            </div>

            <div class="action-container">
                <button type="submit" (click)="makePayment();" [disabled]="!selectedPaymentMode || !termsAccepted"
                    class="pay-button" [class.disabled]="!selectedPaymentMode || !termsAccepted">
                    Pay Now
                </button>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="close-footer-btn" (click)="closeModal()">Cancel</button>
    </div>
</div>